import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { TextField, Box, Button, useTheme } from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';
import SearchIcon from '@material-ui/icons/Search';
import { useIntl } from 'umi';
import DataTableNativeML from '@/components/DataTableNativeML';
import request from '@/utils/request';
import EMPModalStyled from './EMPModalStyled';

export default (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const theme = useTheme();
  const [isRefresh, setIsRefresh] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const { setOpen = () => {}, onConfirm, chooseList, setChooseList } = props;

  const [pageData, setPageData] = useState({
    pageSize: 8,
    pageNum: 1,
  });

  const chooseIdList = useMemo(() => {
    return chooseList?.map((i) => i.id);
  }, [chooseList]);

  const [empName, setEmpName] = useState('');

  const fetchCouponList = useCallback(() => {
    request('/coupon/emp/query/page', {
      method: 'POST',
      data: {
        pageNum: pageData.pageNum,
        pageSize: pageData.pageSize,
        empName: isSearch ? empName : null,
      },
    }).then((res) => {
      setCpList(res.data.data);
      setTotal(res.data.total);
      setPages(res.data.pages);
    });
  }, [pageData, isRefresh]);

  useEffect(() => {
    fetchCouponList();
  }, [fetchCouponList]);

  const [cpList, setCpList] = useState([]);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);
  const columns = [
    {
      type: 'checkbox',
      width: 80,
      onChange: (a, b, c) => {
        console.log({ a, b, c });
        const data = [...chooseList, ...c];
        let chooseArr = [];
        data.forEach((item) => {
          const findItem = chooseArr.some((it) => item.id === it.id);
          if (a.includes(item.id) && !findItem) {
            chooseArr.push(item);
          }
        });
        setChooseList(chooseArr);
      },
    },
    {
      align: 'center',
      title: '人员编号',
      id: 'empNo',
      key: 'empNo',
      width: 180,
    },
    {
      align: 'center',
      title: '人员姓名',
      id: 'empName',
      key: 'empName',
      width: 180,
    },
    {
      align: 'center',
      title: '所在部门',
      id: 'depNames',
      key: 'depNames',
      width: 220,
    },
    {
      align: 'center',
      title: '状态',
      id: 'status',
      key: 'status',
      width: 170,
      render: (rowInfo) => {
        return <div>{rowInfo.status === 'ENABLE' ? '可用' : '冻结'}</div>;
      },
    },
    {
      align: 'center',
      title: '更新时间',
      id: 'updateDate',
      key: 'updateDate',
      width: 170,
    },
  ];

  //换页
  const changePage = (obj) => {
    setPageData({ ...pageData, ...obj });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = () => {
    onConfirm(chooseList);
    setOpen(false);
  };

  const footContent = (
    <div className="modal-btn-wrap">
      <Button onClick={handleClose} variant="contained" color="secondary">
        {formatMessage({ id: 'comm.action.btn.08' })}
      </Button>
      <Button
        variant="contained"
        type="submit"
        className="btnSubmit button"
        onClick={onSubmit}
      >
        {formatMessage({ id: 'comm.action.btn.07' })}
      </Button>
    </div>
  );
  const handleRestClick = () => {
    setIsSearch(false);
    setEmpName('');
    setPageData({ ...pageData, pageNum: 1 });
    setIsRefresh(isRefresh + 1);
  };
  return (
    <EMPModalStyled theme={theme}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 32px',
        }}
      >
        <Box className="coupon-name-wrap">
          <TextField
            className="coupon-name"
            variant="standard"
            onChange={(e) => {
              setEmpName(e.target.value);
              setIsSearch(false);
            }}
            value={empName}
            label="员工姓名"
            placeholder="请输入员工姓名"
          />
          <div></div>
        </Box>
        <Box
          className="button-group"
          sx={{
            display: 'flex',
            gap: '6px',
            flexShrink: 0,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            className="reset"
            onClick={handleRestClick}
            startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
          >
            {formatMessage({ id: 'comm.action.btn.06' })}
          </Button>

          <Button
            variant="contained"
            className="search"
            startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            onClick={() => {
              setPageData({ ...pageData, pageNum: 1 });
              setIsRefresh(isRefresh + 1);
              setIsSearch(true);
            }}
          >
            {formatMessage({ id: 'comm.action.btn.01' })}
          </Button>
        </Box>
      </Box>
      <div className="coupon-list">
        <DataTableNativeML
          columns={columns}
          changePage={changePage}
          page={pageData}
          data={cpList}
          total={total}
          devicesMinWidth="auto"
          chooseIds={chooseIdList}
          paging={true}
          columnKey="id"
          FootContent={footContent}
          initP={true}
          hasNext={pageData.pageNum < pages}
          showPagingData={{ status: true, marginTop: '24px' }}
          showPageColor={true}
          pages={pages}
          np={true}
        ></DataTableNativeML>
      </div>
    </EMPModalStyled>
  );
};
